export default __webpack_public_path__ + "static/media/welcomeInfo.075a4829.png";